<template>
  <div class="container-fluid m-0 p-0">
    <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">Injury/Illness List</span>
        <span class="mx-3">
          <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                  data-toggle="modal"
                  data-target="#add-injury"
          >
            <span class="fas fa-plus"></span>
            Add Record
          </button>
        </span>
        <span class="float-right py-1 mx-2 pr-4">
          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>

    <div class="row text-small pt-3">
      <div class="col col-md-12" style="min-height: 450px !important;">
        <div class="form-group form-inline">
          <label for="inputUser" class="pr-3 font-weight-bold">Search Injury/Illness Here:</label>
          <input class="form-control form-control-sm mr-2 w-25" id="inputUser" style=""
                 type="text" placeholder="Input Any Here . . ."
                 v-model="searchValue"
                 @input="setPage(1)"
          >
          <button type="button" class="btn btn-primary btn-sm"
                  @click="searchValue = ''; setPage(1)"
          >CLEAR</button>

          <label for="injury-illness" class="pr-3 font-weight-bold ml-5">Type: </label>
          <select id="injury-illness" class="form-control form-control-xs input-group-append"
                  v-model="illness"
                  @change="setPage(1)"
          >
            <option :value="''">--- All ---</option>
            <option value="0"> Injury </option>
            <option value="1"> Illness </option>
          </select>

        </div>

        <div class=" table-responsive text-small" style="height: 475px;">
          <table  class="table table-hover table-bordered table-template-1 text-small sticky-header">
            <thead>
            <tr>
              <th>#</th>
              <th>NAME</th>
              <th>TYPE</th>
              <th>STATUS</th>
              <th class="col-actions">ACTION</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(injury, index) in injuries" :key="injury.id" :class="{ inactive: !injury.active }">
              <td>{{ index + pagination.from }}</td>
              <td>{{ injury.name }}</td>
              <td>{{ injury.is_illness ? 'ILLNESS' : 'INJURY' }}</td>
              <td>{{ injury.active ? 'ACTIVE' : 'INACTIVE' }}</td>
              <td class="text-center col-actions">
                <button class="btn btn-sm btn-xs btn-warning font-weight-bolder mr-1 ml-auto"
                        data-toggle="modal"
                        data-target="#edit-injury"
                        @click="viewInjury(injury)"
                >
                  <span class="fas fa-edit"></span>
                  Edit
                </button>
                <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder mr-1 ml-auto"
                        @click="confirmDeleteInjury(injury)"
                >
                  <span class="fas fa-trash-alt"></span>
                  Delete
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <nav aria-label="..." class="ml-3 pt-2">
        <ul class="pagination text-smallest">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
          </li>
        </ul>
      </nav>

    </div>

    <app-modal unique="edit-injury" title="EDIT ILLNESS/INJURY DETAILS">

      <form @submit.prevent="confirmUpdateInjury">
        <div class="form-group form-row mb-1" :class="{'has-error': editInjuryErrors.name }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="injury-name" >
            Name:
          </label>
          <div class="col col-sm-9">
            <input type="text" id="injury-name" required
                   class="form-control form-control-xs"
                   placeholder="INJURY NAME NOT SPECIFIED"
                   v-model="editInjury.name"
            >
            <span class="help-block" v-if="editInjuryErrors.name !== ''">
                <small><strong>{{ editInjuryErrors.name }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editInjuryErrors.is_illness }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="injury-type" >
            Type:
          </label>

          <div class="col col-sm-9">
            <div class="form-check d-block">
              <select class="form-control form-control-xs" id="port-status" v-model="editInjury.is_illness">
                <option :value="1" >ILLNESS</option>
                <option :value="0">INJURY</option>
              </select>
            </div>
            <span class="help-block" v-if="editInjuryErrors.is_illness !== ''">
                <small><strong>{{ editInjuryErrors.is_illness }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editInjuryErrors.active }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="injury-status" >
            Status:
          </label>

          <div class="col col-sm-9">
            <div class="form-check d-block">
              <select class="form-control form-control-xs" id="port-status" v-model="editInjury.active">
                <option :value="1" >ACTIVE</option>
                <option :value="0">INACTIVE</option>
              </select>
            </div>
            <span class="help-block" v-if="editInjuryErrors.active !== ''">
                    <small><strong>{{ editInjuryErrors.active }}</strong></small>
                </span>
          </div>
        </div>

        <hr style="border-color: #E0DED7"/>
        <button type="submit" class="btn btn-sm btn-warning font-weight-bolder float-right">
          <span class="fas fa-edit"></span>
          Update
        </button>

      </form>
    </app-modal>

    <app-modal unique="add-injury" title="ADD ILLNESS/INJURY RECORD">

      <form @submit.prevent="confirmAddInjury">
        <div class="form-group form-row mb-1" :class="{'has-error': newInjuryErrors.name }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-injury-name" >
            Name:
          </label>
          <div class="col col-sm-9">
            <input type="text" id="new-injury-name" required
                   class="form-control form-control-xs"
                   placeholder="INJURY NAME NOT SPECIFIED"
                   v-model="newInjury.name"
            >
            <span class="help-block" v-if="newInjuryErrors.name !== ''">
                <small><strong>{{ newInjuryErrors.name }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newInjuryErrors.is_illness }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-injury-type" >
            Type:
          </label>

          <div class="col col-sm-9">
            <div class="form-check d-block">
              <select class="form-control form-control-xs" id="port-status" v-model="newInjury.is_illness">
                <option :value="1">ILLNESS</option>
                <option :value="0">INJURY</option>
              </select>
            </div>
            <span class="help-block" v-if="newInjuryErrors.is_illness !== ''">
                <small><strong>{{ newInjuryErrors.is_illness }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newInjuryErrors.active }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-injury-status" >
            Status:
          </label>

          <div class="col col-sm-9">
            <div class="form-check d-block">
              <select class="form-control form-control-xs" id="port-status" v-model="newInjury.active">
                <option value="">Select..</option>
                <option :value="1" >ACTIVE</option>
                <option :value="0">INACTIVE</option>
              </select>
            </div>
            <span class="help-block" v-if="newInjuryErrors.active !== ''">
                    <small><strong>{{ newInjuryErrors.active }}</strong></small>
                </span>
          </div>
        </div>

        <hr style="border-color: #E0DED7"/>
        <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder float-right">
          <span class="fas fa-save"></span>
          Save
        </button>

      </form>
    </app-modal>

  </div>
</template>

<script>

import AppModal from "@/components/elements/AppModal";

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { paginationMixin } from "@/mixins/paginationMixin";

export default {
  name: "InjuryIndex",

  mixins: [ vueAppMixin, paginationMixin ],

  components: { AppModal },

  data() {
    return {
      searchValue: '',
      illness: '',

      editInjury: {},
      editInjuryErrors: {},

      newInjury: {
        is_illness: 1,
        active: ''
      },
      newInjuryErrors: {},

    }
  },

  methods: {
    ...mapActions([
        'getInjuries',
        'updateInjury',
        'addInjury',
        'deleteInjury'
    ]),

    initializeData() {
      this.getInjuries({});
    },

    viewInjury(injury) {
      this.editInjury = Object.assign({}, injury);
      this.editInjuryErrors = {}
    },

    setPage(page) {
      this.pagination.currentPage = page;
      this.searchInjury();
    },

    searchInjury() {
      let params = {
        page: this.pagination.currentPage,
        searchValue: this.searchValue,
      };
      if(this.illness !== '') params['illness'] = this.illness;
      this.getInjuries(params);
    },

    async confirmUpdateInjury() {
      if(await this.confirmUpdate()) {
        let params = {
          id: this.editInjury.id,
          name: this.editInjury.name,
          is_illness: this.editInjury.is_illness,
          active: this.editInjury.active,
        };
        let updatedInjury = await this.updateInjury(params);
        if(updatedInjury) {
          if(updatedInjury.errors) {
            this.editInjuryErrors = updatedInjury.errors;
          } else {
            this.successAlert('Injury Successfully Updated', 'UPDATE');
            this.editInjury = {};
            this.editInjuryErrors = {};
            document.getElementById('close-edit-injury').click();
          }
        }
      }
    },

    async confirmAddInjury() {
      if(await this.confirmCreateAlert()) {
        let params = {
          name: this.newInjury.name,
          is_illness: this.newInjury.is_illness,
          active: this.newInjury.active,
        };
        let newInjury = await this.addInjury(params);
        if(newInjury) {
          if(newInjury.errors) {
            this.newInjuryErrors = newInjury.errors;
          } else {
            this.successAlert('Injury Successfully Added', 'CREATE');
            this.newInjury = {};
            this.newInjuryErrors = {};
            document.getElementById('close-add-injury').click();
          }
        }
      }
    },

    async confirmDeleteInjury(injury) {
      if(await this.confirmDeleteAlert()) {
        let params = { id: injury.id };
        let deletedInjury = await this.deleteInjury(params);
        if(deletedInjury) {
          let type = injury.is_illness ? 'Illness' : 'Injury'
          this.successAlert(`${type} Successfully Deleted', 'DELETED`);
        }
      }
    }

  },

  computed: {
    ...mapGetters([
        'injuries'
    ])
  },

  created() {
    this.initializeData();
  }

}
</script>

<style scoped>

</style>
